import script from "./CompanyDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CompanyDashboard.vue?vue&type=style&index=0&id=2c8be11e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8be11e"]])

export default __exports__